var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3334V6.66671C13.3333 6.44569 13.2455 6.23373 13.0892 6.07745C12.9329 5.92117 12.7209 5.83337 12.4999 5.83337H4.16659C3.94557 5.83337 3.73361 5.92117 3.57733 6.07745C3.42105 6.23373 3.33325 6.44569 3.33325 6.66671V13.3334C3.33325 13.5544 3.42105 13.7663 3.57733 13.9226C3.73361 14.0789 3.94557 14.1667 4.16659 14.1667H12.4999C12.7209 14.1667 12.9329 14.0789 13.0892 13.9226C13.2455 13.7663 13.3333 13.5544 13.3333 13.3334Z",
    stroke: "#E86747",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L14 8.4V11.6L18 14V6Z",
    stroke: "#E86747",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOn);
export default __webpack_public_path__ + "static/media/cam-on.a7f5f3e2a30363110d81897fa1b6a261.svg";
export { ForwardRef as ReactComponent };